import { useParams } from "@tanstack/react-router";

import {
  HeaderTabs,
  type TabWithIndicatorProps,
} from "@/components/Navigation/HeaderTabs";
import { defaultNS, useTranslation } from "@/lib/i18n";

export default function GroupIdHeaderTabs() {
  const proxyUserId = useParams({
    from: "/_staff/ids/group-id/$id/_$id",
  }).id;
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.idManagements.groupId.details.tabs",
  });

  const links: TabWithIndicatorProps[] = [
    {
      to: "/ids/group-id/$id/members",
      params: { id: proxyUserId },
      children: t("members"),
    },
    {
      to: "/ids/group-id/$id/rule-and-policy",
      params: { id: proxyUserId },
      children: t("ruleAndPolicy"),
    },
    {
      to: "/ids/group-id/$id/settings",
      params: { id: proxyUserId },
      children: t("settings"),
    },
  ];

  return <HeaderTabs tabs={links} />;
}
